<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0942 18.3317H14.5931C17.5108 18.3317 18.7608 16.665 18.7608 14.165V5.83167C18.7608 3.33167 17.5108 1.665 14.5931 1.665H7.42642C4.50867 1.665 3.25867 3.33167 3.25867 5.83167"
      :stroke="color"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.2148 3.75V5.41667C13.2148 6.33333 14.0065 7.08333 14.9815 7.08333H16.7315"
      :stroke="color"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <g clip-path="url(#clip0_27647_297296)">
      <path
        d="M9.1020 11.1977V12.3144H2.43594V9.90234H7.73047C8.46602 9.90234 9.1020 10.4827 9.1020 11.1977Z"
        :fill="color"
      />
      <path
        d="M2.43594 13.1104H9.1020V14.2270C9.1020 14.9431 8.46602 15.5234 7.73047 15.5234H3.89531C3.16667 15.5234 2.43594 14.9431 2.43594 14.2270V13.1104Z"
        :fill="color"
      />
      <path
        d="M4.15190 17.4985C3.73448 17.5065 3.39544 17.2021 3.38640 16.8164C3.37849 16.4316 3.70281 16.1126 4.08859 16.1036C4.47438 16.0990 4.81231 16.4034 4.82367 16.7880C4.82814 17.1727 4.50269 17.4895 4.15190 17.4974"
        :fill="color"
      />
      <path
        d="M6.65821 16.7963C6.66268 16.4127 6.97676 16.105 7.36028 16.1084C7.74380 16.1129 8.05194 16.4275 8.04859 16.8110C8.04413 17.1945 7.72960 17.5023 7.34608 17.4989C6.96368 17.4966 6.65555 17.1855 6.65821 17.8031C6.65821 16.8009 6.65821 16.7986 6.65821 16.7963Z"
        :fill="color"
      />
      <path
        d="M7.71946 9.16761H3.89844V7.91520C3.89844 7.68667 4.0625 7.5 4.31966 7.5H7.30013C7.55367 7.5 7.72054 7.68554 7.72054 7.91520V9.16761H7.71946Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_27647_297296">
        <rect
          width="6.66667"
          height="10"
          fill="white"
          transform="translate(2.4375 7.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  color: {
    type: String,
    default: "black",
  },
});
</script>
